module.exports = __webpack_public_path__ + "app/components/alerts/alert-details-tracker.view.html";